import {
  useV2CreateServiceConditionMutation,
  useV2UpdateServiceConditionMutation,
  useV2DeleteServiceConditionMutation,
  useV2ChangeServiceConditionPositionByIdMutation,
} from "@generated";
import type { V2ServiceConditionResource } from "@generated";
import type { ServiceConditionFormValues } from "../types";

export const buildServiceConditionData = (
  values: ServiceConditionFormValues,
  id?: string
): V2ServiceConditionResource =>
  ({
    type: "service-conditions",
    ...(id ? { id } : {}),
    attributes: {
      name: values.name,
      content: values.content,
      status: values.status,
    },
  } as unknown as V2ServiceConditionResource);

const movePositionData = (
  id: string,
  position: number
): V2ServiceConditionResource =>
  ({
    type: "service-conditions",
    id: id,
    attributes: { position },
  } as unknown as V2ServiceConditionResource);

export const useServiceConditionMutations = () => {
  const [create] = useV2CreateServiceConditionMutation();
  const [update] = useV2UpdateServiceConditionMutation();
  const [destroy] = useV2DeleteServiceConditionMutation();
  const [move] = useV2ChangeServiceConditionPositionByIdMutation();

  return {
    create: (values: ServiceConditionFormValues) =>
      create({ body: { data: buildServiceConditionData(values) } }).unwrap(),
    update: (id: string, values: ServiceConditionFormValues) =>
      update({
        id: id,
        body: { data: buildServiceConditionData(values, id) },
      }).unwrap(),
    archive: (id: string) => destroy({ id: id }).unwrap(),
    move: (id: string, position: number) =>
      move({
        id: id,
        body: { data: movePositionData(id, position) },
      }).unwrap(),
    restore: (id: string, name: string) =>
      update({
        id: id,
        body: {
          data: {
            type: "service-conditions",
            id: id,
            attributes: { name, active: true },
          } as unknown as V2ServiceConditionResource,
        },
      }).unwrap(),
  };
};

export default useServiceConditionMutations;
